import React, { useEffect, useState } from "react";
import { Breadcrumb, Card, Col, Container, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";
import axios from "axios";
import { apiBaseURL } from "../../Common/ApiHelper";
const OrderSummary = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    handleSubmit();
  }, []);
  const userData = JSON.parse(localStorage.getItem("userData"));

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await axios({
        method: "get",
        url: `${apiBaseURL}user/getOrderHistory?email=${userData.email}`,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (response?.status === 200) {
        setTableData(response?.data?.data);
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      console.log("error", e);
    }
  };
  const handleDate = (dateString) => {
    const date = new Date(dateString);

    const year = date.getUTCFullYear();
    const month = date.getUTCMonth() + 1; // months are zero-indexed
    const day = date.getUTCDate();

    const formattedDate = `${year}/${month.toString().padStart(2, "0")}/${day
      .toString()
      .padStart(2, "0")}`;

    return formattedDate;
  };
  return (
    <>
      <div className="main">
        <Container className="py-5 px-1">
          <Breadcrumb>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/")}
              >
                Home
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small className="BreadCrumbs_style">Account</small>
            </Breadcrumb.Item>
          </Breadcrumb>
          <Row>
            <Col md={3} xl={3}>
              <div className="d-grid gap-2 pb-4 Account_card_div">
                <div className="Account_btns Account_cards align_center">
                  <h6 className="m-3">
                    <b>
                      Welcome back, <br />
                      {userData?.firstName + " " + userData?.lastName}{" "}
                    </b>
                  </h6>
                </div>
              </div>
              <div className="d-grid gap-2 pb-3 Account_card_div">
                <div className="Account_btns Account_cards p-4 align_center">
                  <h6 className="pt-2 ">
                    <b>Have Questions?</b>
                  </h6>
                  <p className="text_muted">
                    Call (833) 465 0300 <br /> or contact us via chat.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={9} xl={9}>
              <Card className="Account_Main_Card box_shadow">
                <Card.Header className="blue_bg Account_Card_Header ">
                  <Container>
                    <Row>
                      <Col className="Header_Text ps-5 ">
                        <b>Order Summary</b>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                {loading ? (
                  <div class="d-flex justify-content-center">
                    <span
                      class="spinner-border spinner-border-lm me-3 m-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </div>
                ) : (
                  <Card.Body>
                    <Table hover>
                      <thead>
                        <tr>
                          <th className="hideTable_sno">Sno.</th>
                          <th>Order Id</th>
                          <th className="hideTable_date">Date</th>
                          <th>Price</th>
                          <th>View</th>
                        </tr>
                      </thead>
                      {tableData?.map((item, index) => {
                        return (
                          <tbody>
                            <tr>
                              <td className="hideTable_sno">{index + 1}</td>
                              <td>{item?.orderId}</td>
                              <td className="hideTable_date">
                                {handleDate(item?.createdAt)}
                              </td>
                              <td>${item?.payAmount} </td>
                              <td>
                                <div
                                  onClick={() =>
                                    navigate(`/account_area/${item?.orderId}`)
                                  }
                                >
                                  <AiOutlineEye className="view_icon" />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        );
                      })}
                    </Table>
                  </Card.Body>
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default OrderSummary;
